import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError } from 'rxjs';

/**
 * Fuse template interceptor (uses `accessToken` key).
 * Portal auth uses `jwt` / `refreshToken` via TokenInterceptor + LoaderInterceptor.
 * Do not sign out / reload on 401 here — that races the real refresh flow and can
 * wipe a still-valid 30-day refresh token after overnight access expiry.
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const authService = inject(AuthService);

    let newReq = req.clone();

    if ( authService.accessToken && !AuthUtils.isTokenExpired(authService.accessToken) )
    {
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + authService.accessToken),
        });
    }

    return next(newReq).pipe(
        catchError((error) =>
        {
            // Only clear the unused Fuse accessToken key; never reload or clear portal tokens.
            if ( error instanceof HttpErrorResponse && error.status === 401 && authService.accessToken )
            {
                authService.signOut();
            }

            return throwError(() => error);
        }),
    );
};
